import React, { Component } from 'react'
import SecuritySettingsForm from '../forms/SecuritySettingsForm'

class SecurityTab extends Component {
    render() {
        return (
            <div className="security-tab">
                <SecuritySettingsForm />
            </div>
        )
    }
}

export default SecurityTab